import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import TextareaCounter from './../../FormComponents/TextareaCounter';

export default function Mandatory({ values, onChange, errors, setRef, preferences }) {
  const { schema } = preferences;
  const { dental_preferences } = schema;
  const { general_information } = dental_preferences.properties;
  return (
    <div className="mandatory no-margin">
      {general_information?.properties?.address_details && 
      <>
      <div className="mandatory__row">
        <p className="mandatory__row__label">
          Practice address<sup>*</sup>
        </p>
        <div className="mandatory__row__input" >
        <TextareaCounter
            rows="3"
            name="address_details_address"
            placeholder="Enter address"
            value={values.address_details_address}
            onChange={onChange}
            maxLength={160}
            className={classnames({ 'has-error': errors[`address_details_address`] })}
            // ref={setRef}
            ref={(c) => {
              setRef(c, `address_details_address`);
            }}
          />
           <span className="message--small message--error">
            {errors['address_details_address'] &&
              errors['address_details_address'].message}
          </span>
        </div>
      </div>

        <div className="mandatory__row">
        <p className="mandatory__row__label">
            Location tip
        </p>
        <div className="mandatory__row__input">
        <TextareaCounter
            rows="3"
            name="address_details_location_tip"
            placeholder="Location tip"
            value={values.address_details_location_tip}
            maxLength={160}
            onChange={onChange}
            // className={classnames({ 'has-error': errors[`address_details.${index}.address`] })}
            // ref={(c) => {
            //   setRef(c, `address_details.${index}.address`);
            // }}
          />
        </div>
        </div>

        <div className="mandatory__row">
        <p className="mandatory__row__label">
            Parking tip
        </p>
        <div className="mandatory__row__input">
        <TextareaCounter
            rows="3"
            name="address_details_parking_tip"
            placeholder="Parking tip"
            value={values.address_details_parking_tip || ''}
            onChange={onChange}
            maxLength={160}
            // className={classnames({ 'has-error': errors[`address_details.${index}.address`] })}
            // ref={(c) => {
            //   setRef(c, `address_details.${index}.address`);
            // }}
          />
        </div>
        </div>
        </>}
      {/* <div className="mandatory__row">
        <p className="mandatory__row__label">
          Best phone number to reach business
          <sup>*</sup>
        </p>
        <div className="mandatory__row" style={{ textAlign: 'right' }}>
          <div className="mandatory__row__input">
            <FormattedField
              style={{ width: '75%' }}
              format="(###) ###-####"
              mask="_"
              value={values.business_contact_number || ''}
              onChange={getHandler('business_contact_number')}
              error={errors.business_contact_number}
            />
          </div>
        </div>
      </div> */}

      {/* <div className="mandatory__row">
        <p className="mandatory__row__label">
          What would you like the first text message to your patient to say?
          <sup>*</sup>
          <br />
          <span className="hint-text">
            Note: Please don&apos;t enter phone numbers or URLs as part of this first message.
          </span>
        </p>
        <div className="mandatory__row" style={{ textAlign: 'right' }}>
          <div className="mandatory__row__input">
            <TextareaField
              count
              max={160}
              style={{ width: 300 }}
              label=""
              placeholder={'Enter first message'}
              value={values.first_message || ''}
              onChange={getHandler('first_message')}
              error={errors.first_message}
              className={classnames({ 'has-error': errors.first_message })}
            />
          </div>
        </div>
      </div> */}
    </div> 
  );
}

Mandatory.defaultProps = {
  onChange: () => {},
  getHandler: () => {},
  values: {},
  errors: {},
};

Mandatory.propTypes = {
  getHandler: PropTypes.func,
  values: PropTypes.shape(),
  errors: PropTypes.shape(),
};
